import { Button } from '@workspace/ui/components/Button';
import { Typography } from '@workspace/ui/components/Typography';
import { cn } from '@workspace/ui/lib/utils';
import { observer } from 'mobx-react-lite';
import type React from 'react';
import { useRef } from 'react';

import { DeliveryTimeWarning } from '~/components/HeaderV3/components/DeliveryTimeWarning';
import Icon from '~/components/Icon/Icon';
import { useCartButton } from '~/hooks/useCartButton';
import { useMounted } from '~/hooks/useMounted';

const BRAND_CART_CLASSES =
  'size-12! max-h-none! p-0! border-transparent bg-navigation-action-brand text-navigation-text-in-button hover:bg-navigation-action-brand-hover';
const BADGE_CLASSES =
  'pointer-events-none absolute -top-[6px] -right-1 flex size-6 items-center justify-center rounded-full bg-navigation-bg-2 shadow-[0_0_0_1.4px_rgba(45,47,51,0.17)]';
const BADGE_TEXT_CLASSES = 'text-navigation-text-brand';

export const CartButton = observer<
  Omit<React.ComponentPropsWithoutRef<'div'>, 'children'>
>(({ className, ...props }) => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const { cartBadgeLabel, handleNavigateCart } = useCartButton();
  const mounted = useMounted();

  return (
    <div {...props} className={cn('relative', className)} ref={buttonRef}>
      <Button
        variant="brand"
        startIcon={<Icon type="cart-3.1" width={18} height={17} />}
        className={BRAND_CART_CLASSES}
        onClick={handleNavigateCart}
        data-button="header-cart"
      />
      {mounted && cartBadgeLabel && (
        <div className={BADGE_CLASSES}>
          <Typography.Text200Semibold as="span" className={BADGE_TEXT_CLASSES}>
            {cartBadgeLabel}
          </Typography.Text200Semibold>
        </div>
      )}
      <DeliveryTimeWarning buttonRef={buttonRef} />
    </div>
  );
});
CartButton.displayName = 'CartButton';
